import React from "react";
import { BeginnerIcon } from "../Icons/beginner-icon";
import { PromotionBanners } from "../homepage/PromotionBanners";
import { SNSIcons } from "../mypage/SNSIcons";

interface TopMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TopMenu: React.FC<TopMenuProps> = ({ isOpen, onClose }) => {
  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const menuItems = [
    {
      title: "はじめ方",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe40801295d4d6778c4457bb?pvs=4",
      isExternal: true,
    },
    {
      title: "ゲーム説明・遊び方",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe4080f18d01ddf1958e51ee?pvs=4",
      isExternal: true,
    },
    {
      title: "安心安全の取り組みについて",
      href: "https://thumba.jp/media/216",
      isExternal: true,
    },
    {
      title: "ヘルプ",
      href: "https://half-pressure-b6c.notion.site/1a6941dfbe408057ba5afe0e9566b691?v=1a6941dfbe408139805a000c5955c327&pvs=4",
      isExternal: true,
    },
    { title: "お問い合わせ", href: "https://lin.ee/wk85Btz", isExternal: true },
    {
      title: "利用規約",
      href: "/terms-of-service",
      isExternal: false,
    },
    {
      title: "プライバシーポリシー",
      href: "/privacy-policy",
      isExternal: false,
    },
  ];

  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 z-10" onClick={onClose} />
      <div className="fixed left-0 top-[72px] w-screen max-w-full sm:max-w-[400px] h-[calc(100dvh-72px)] bg-white z-50">
        <div className="w-full">
          <PromotionBanners />
        </div>

        <div className="p-4 safe-area-inset-bottom pb-8">
          <div className="mb-4">
            <div className="flex items-center gap-3">
              <BeginnerIcon />
              <h2 className="text-[15px] leading-tight font-bold py-2">初めての方へ</h2>
            </div>
            <div className="flex w-full border-b-2 border-secondary py-2 mb-2" />
            <div className="space-y-3">
              {menuItems.slice(0, 3).map((item) => (
                <div key={item.href}>
                  <a
                    href={item.href}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                    className="cursor-pointer mx-2 text-[14px] leading-tight block"
                    onClick={() => onClose()}
                  >
                    {item.title}
                  </a>
                  <div className="flex border-b border-gray mt-3" />
                </div>
              ))}
            </div>
          </div>
          {/* SNS Icons */}
          <SNSIcons className="mb-4" />

          <div className="mb-4">
            <h2 className="text-[15px] leading-tight font-bold mt-6">その他</h2>
            <div className="flex w-full border-b-2 border-secondary py-2 mb-2" />
            <div className="space-y-3">
              {menuItems.slice(3).map((item) => (
                <div key={item.href}>
                  <a
                    href={item.href}
                    target={item.isExternal ? "_blank" : undefined}
                    rel={item.isExternal ? "noopener noreferrer" : undefined}
                    className="cursor-pointer mx-2 text-[14px] leading-tight block"
                    onClick={() => onClose()}
                  >
                    {item.title}
                  </a>
                  <div className="flex border-b border-gray mt-3" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
